'use client'

import { AppErrorBoundary } from '@phoenix-web/react-shared/client-components'
import { trackError } from '@/lib/error-logger'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <AppErrorBoundary error={error} reset={reset} trackError={trackError} />
}
